<template>
    <aside class="aside">
        <div class="aside-logo"><img :class="logoImg" :src="imgSrc" alt=""></div>
        <a-menu v-model="selectedKeys"
                :openKeys.sync="openKeys"
                mode="inline"
                theme="dark"
                @click="menu"
                :inlineCollapsed="aside_collapsed">
            <template v-for="(item) in routes">
                <a-menu-item :key="item.name"
                            v-if="!item.meta.unfold">
                    <icon :type="item.meta.iconType" />
                    <span>{{ item.meta.name }}</span>
                </a-menu-item>
                <aside-item v-else
                            :menuInfo="item"
                            :key="item.name"
                            :listByMeCount="listByMeCount"
                            :listByConfirmCount="listByConfirmCount"
                            ></aside-item>
            </template>
        </a-menu>
    </aside>
</template>

<script type="text/javascript">
    import { mapMutations, mapGetters } from "vuex";

    import AsideItem from "./aside-item.component";
    import UserInfoTool from '@/plugins/user-info-tool.js';

    export default {
        name: "aside-component",
        data() {
            return {
                routes: [],
                selectedKeys: [],
                openKeys: [],
                imgSrc: require('../../assets/image/icon-nav-logo.png'),
                logoImg: 'aside-logo-big',
                listByMeCount: 0,
                listByConfirmCount: 0,
                timer: null
            };
        },
        components: {
            AsideItem
        },
        computed: {
            ...mapGetters(["aside_collapsed"])
        },
        watch: {
            $route() {
                this.setRoute();
            },
            'aside_collapsed'(val) {
                if(val) {
                    this.imgSrc = require('../../assets/image/icon-nav-avatar.png');
                    this.logoImg = 'aside-logo-small';
                }else {
                    this.imgSrc = require('../../assets/image/icon-nav-logo.png')
                    this.logoImg = 'aside-logo-big';
                }
            }
        },

        methods: {
            menu(item) {
                this.$router.push({
                    name: item.key
                });
            },

            /**
             * 设置默认选中和展开的key
             * @param route 路由
             * @param routeName 当前路由 name
             */
            setDefaultKey(route, routeName) {
                this.selectedKeys = route.meta.unfold ? [routeName] : [route.name];
                this.openKeys.push(route.name);
            },

            // 初始化时设置侧边栏类目选中
            initDefalutKey() {
                const name = this.$route.name;
                let matched = this.$route.matched;

                for (let index = 0; index < matched.length - 1; index++) {
                    let el = matched[index];
                    if (!el.meta.unfold && !index) {
                        this.setDefaultKey(el, name);
                        break;
                    }
                    this.setDefaultKey(el, name);
                }
            },
            // 设置路由
            setRoute() {
                const authList = this.$utils.deepClone(UserInfoTool.getAuth());
                const parentList = authList.filter(item => item && item.level === 1);
                const childList = authList.filter(item => item && item.level === 2);

                if(!parentList.length) return this.routes = [];
                const routes = this.$router.options.routes.filter(el => {
                    // return el.children && !el.meta.hide;
                    return el.children;
                });

                routes.forEach((item, index) => {
                    let parent = parentList.find(el => {
                        return el.routeName === item.name
                    });
                    item.meta.hide = !parentList.some(child => {
                        return child.routeName === item.name;
                    });

                    parent && item.children.forEach(child => {
                        let authChild = childList.find(el => {
                            return el.routeName === child.name && el.parentId === parent.id;
                        });
                        authChild && (child.meta.parentId = authChild.id);
                        child.meta.hide = !childList.some(authChild => {
                            return child.name === authChild.routeName && authChild.parentId === parent.id;
                        });
                    })
                });

                this.routes = routes.filter(el => {
                    return !el.meta.hide;
                });

                this.initDefalutKey()
            },
            // 获取审核管理我发起的数量
            listByMe () {
                this.$api.audit.listByMe({
                    body:{
                        pageNum: 1,
                        pageSize: 999,
                        state: '0'
                    }
                }).then(data => {
                    this.listByMeCount = data.total;
                })
            },
            // 获取审核管理待我确认数量
            listByConfirm() {
                this.$api.audit.listByConfirm({
                    body: {
                        pageNum: 1,
                        pageSize: 999,
                        state: '0',
                    }
                }).then(data => {
                    this.listByConfirmCount = data.total;
                })
            },
        },
        created() {
            this.initDefalutKey()
        },
        mounted() {
            this.setRoute();
            this.listByMe();
            this.listByConfirm();

            // 监听，当当前用户权限变更时重新计算是否显示项目
            this.$eventBus.on('auth:refresh', () => {
                this.setRoute();
            }, this);
            this.$eventBus.on('refreshAutid', () => {
                this.listByMe();
                this.listByConfirm();
            }, this);
            if(this.aside_collapsed) {
                this.imgSrc = require('../../assets/image/icon-nav-avatar.png');
                this.logoImg = 'aside-logo-small';
            }else {
                this.imgSrc = require('../../assets/image/icon-nav-logo.png');
                this.logoImg = 'aside-logo-big';
            }
            // 每10分钟拉取一次审核数据
            this.timer = setInterval(() => {
                this.listByMe();
                this.listByConfirm();
            },10*60000)
        },
        beforeDestroy() {
            clearInterval(this.timer)
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .aside {
        background: #53311a;
        overflow-x: hidden;
        overflow-y: auto;
        position: relative;
        box-shadow: 2px 0px 6px 0px rgba(0, 21, 41, 0.35);
        z-index: 1000;
        &::-webkit-scrollbar {
            display: none;
        }
        &-logo {
            height: 64px;
            line-height: 64px;
            padding-left: 10px;
            &-big {
                width: 150px;
            }
            &-small {
                width: 40px;
            }
        }
        .ant-menu-inline {
            width: 184px;
        }
        .ant-menu-item,
        .ant-menu-submenu {
            .icon,.anticon {
                color: $text-color-white-85;
                &:before {
                    margin-right: 10px;
                }
            }
        }

        .ant-menu-inline-collapsed {
            width: 64px;

            .icon + span,
            .anticon + span {
                opacity: 0;
            }

            .ant-menu-item {
                padding: 0 25px !important;
            }

            .ant-menu-submenu {
                .ant-menu-submenu-title {
                    padding: 0 25px !important;
                }
            }
        }
        .ant-menu-dark {
            background-color: #53311a;
        }
        .ant-menu-dark,.ant-menu-sub,.ant-menu-dark .ant-menu-inline.ant-menu-sub {
            background-color: #3d2413;
        }
        .ant-menu-submenu {
            background-color: #6b442a;
        }
        .ant-badge-count {
            top: 7px !important;
            right: -16px !important;
        }
    }
</style>
